const messages = {
  MIN_1_CHAR: "최소 1글자 이상 입력해주세요.",
  COLLECTION_NAME_EXISTS: "이미 존재하는 컬렉션 이름입니다.",
};

export default messages;
